import React, { Component } from 'react';

class FeatureRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Step-by-Step Guidance',
                    text: 'Simplified techniques that anyone can understand and apply.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Stay Compliant',
                    text: 'Ensure your savings are fully compliant with tax laws.'
                },
            ]
        }
    }

    render() {
        return (
            <div className="topic-items">
                {
                    this.state.collRight.map((data, i) => (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>

                    ))
                }
            </div>
        );
    }

}

export default FeatureRight;
